import api from "../../services/api";

const path = "v1/log";

export const postLog = async ({
  EmailUsuario,
  Descricao,
  Tabela,
  Origem,
  Dados,
}) => {
  return await api.post(`${path}`, {
    EmailUsuario,
    Descricao,
    Tabela,
    Origem,
    Dados,
  });
};
